module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e7f29f2cddb213cba47098c2e77debe3.gif";